/*
 * Project: LegalPlace assistant
 * File: src\tracking\pattern_detector.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/


import { b64EncodeUnicode, b64DecodeUnicode } from '../logic/utils/encoding';
import lpevents from './lpevents';
import { store } from '../globals';


class PatternTracker {
  constructor() {
    const state = store.getState();
    this.events = [];
    this.last_action = 'none';
    this.user_agent = navigator.userAgent;
    this.window_size = {
      height: window.innerHeight,
      width: window.innerWidth,
    };
    this.language = navigator.language;
    this.languages = navigator.languages;
    this.last_action_time = 0;
    this.price_one = state.checkout_operations.prices.first_price;
    this.price_two = state.checkout_operations.prices.second_price;
    this.selected_price = state.checkout_operations.pack;
    this.base_time = new Date().getTime();
  }

  init() {
    const state = store.getState();
    this.events = [];
    this.last_action = 'none';
    this.user_agent = navigator.userAgent;
    this.window_size = {
      height: window.innerHeight,
      width: window.innerWidth,
    };
    this.language = navigator.language;
    this.languages = navigator.languages;
    this.last_action_time = 0;
    this.price_one = state.checkout_operations.prices.first_price;
    this.price_two = state.checkout_operations.prices.second_price;
    this.selected_price = state.checkout_operations.pack;
    this.base_time = new Date().getTime();
  }

  /**
     *
     * @param {string} id
     */
  trackInPayment(id) {
    const params = {};
    // getting the last one
    const keys = Object.keys(this.events);
    let t;
    if (keys.length == 0) t = (new Date().getTime()) - this.base_time;
    else t = (new Date().getTime()) - this.base_time - keys[keys.length - 1];
    t = Math.floor(t / 100);
    params[t] = id;
    this.events.push(params);
  }

  trackLastAction(id) {
    const state = store.getState();
    this.last_action = id;
    this.last_action_time = new Date().getTime();
    this.selected_price = state.checkout_operations.pack;
  }

  encode() {
    let result = '';
    this.events.map((idx) => {
      const key = Object.keys(idx)[0];
      result += `${key} ${idx[key]},`;
    });
    return b64EncodeUnicode(JSON.stringify(result));
  }

  /**
     *
     * @param {string} events
     */
  decode(events) {
    return JSON.parse(b64DecodeUnicode(events));
  }

  sendAndResetTracker() {
    const params = {};
    params.pattern = {};
    const that = this;
    Object.keys(this).map((idx) => {
      if (idx == 'events') params[idx] = that.encode();
      else {
        params[idx] = that[idx];
      }
    });
    lpevents.track('Checkout Pattern', params);
    this.init();
  }
}

export const lpPattern = new PatternTracker();
window.lpPattern = lpPattern;


export const P_CLOSE_PAYMENT = 0;
export const P_SELECT_PACK_1 = 1;
export const P_SELECT_PACK_2 = 2;
export const P_SELECT_PACK_3 = 3;
export const P_SELECT_PACK_4 = 4;
export const P_ADD_CALL = 3;
export const P_REMOVE_CALL = 4;
export const P_ADD_LETTER = 5;
export const P_REMOVE_LETTER = 6;
export const P_CHANGE_LETTER = 7;
export const P_UPDATE_ADDRESS = 8;
export const P_CHECK_PREVIEW = 9;
export const P_TRYING_PROMO = 10;
export const P_CHECK_PROMO = 11;
export const P_CLOSE_PAIMENT = 12;
export const P_REQUEST_MODAL = 13;
export const P_SUBSCRIBE = 14;

// last actions
export const P_PAY = 20;
export const P_BACK = 19;



// WEBPACK FOOTER //
// ./src/tracking/pattern_detector.js